import { render, staticRenderFns } from "./WheelInfoModal.vue?vue&type=template&id=a12dbd02&"
import script from "./WheelInfoModal.vue?vue&type=script&lang=js&"
export * from "./WheelInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports